import SatisfactionModal from './SatisfactionModal.vue'

export default SatisfactionModal
